{
  "name": "@apfelkiste/sink",
  "version": "1.5.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@apfelkiste/dy": "*",
    "@homer.api/homer": "*",
    "@homer.core/application": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/storage.local": "*",
    "@unifold/core": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
